import { consumer, IResponse } from '@bemap/utils';

export interface Word {
  id: string;
  order: number;
  word: string;
  word_es: string;
  word_en: string;
  profileType: 'E' | 'C' | 'A' | 'P';
  category: 'positive' | 'negative';
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

interface ApiError {
  response?: {
    status?: number;
    data?: {
      message?: string;
    };
  };
}

export class WordsService {
  static async getWords(isActive?: boolean): Promise<IResponse> {
    const url = isActive !== undefined ? `/words?isActive=${isActive}` : `/words`;

    try {
      return await consumer('GET', url);
    } catch (error: unknown) {
      const apiError = error as ApiError;
      const msg = apiError.response?.data?.message || 'Failed to load words';
      throw {
        statusCode: apiError.response?.status || 500,
        message: msg
      };
    }
  }

  static async getWordById(id: string): Promise<IResponse> {
    const url = `/words/${id}`;

    try {
      return await consumer('GET', url);
    } catch (error: unknown) {
      const apiError = error as ApiError;
      const msg = apiError.response?.data?.message || 'Failed to load word';
      return {
        statusCode: apiError.response?.status || 500,
        message: msg
      };
    }
  }

  static async createWord(word: Omit<Word, 'id' | 'createdAt' | 'updatedAt'>): Promise<IResponse> {
    const url = `/words`;

    try {
      return await consumer('POST', url, word);

    } catch (error: unknown) {
      const apiError = error as ApiError;
      const msg = apiError.response?.data?.message || 'Failed to create word';
      throw {
        statusCode: apiError.response?.status || 500,
        message: msg
      };
    }
  }

  static async updateWord(word: Word): Promise<IResponse> {
    const url = `/words/${word.id}`;

    try {
      return await consumer('PUT', url, word);

    } catch (error: unknown) {
      const apiError = error as ApiError;
      const msg = apiError.response?.data?.message || 'Failed to update word';
      throw {
        statusCode: apiError.response?.status || 500,
        message: msg
      };
    }
  }

  static async deleteWord(id: string): Promise<IResponse> {
    const url = `/words/${id}`;

    try {
      return await consumer('DELETE', url);
    } catch (error: unknown) {
      const apiError = error as ApiError;
      const msg = apiError.response?.data?.message || 'Failed to delete word';
      throw {
        statusCode: apiError.response?.status || 500,
        message: msg
      };
    }
  }
} 